import { render, staticRenderFns } from "./EditorImageMenu.vue?vue&type=template&id=2f78ae74&"
import script from "./EditorImageMenu.vue?vue&type=script&lang=js&"
export * from "./EditorImageMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditorImageMenu.vue?vue&type=style&index=0&id=2f78ae74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VMenu})
